import Vue from 'vue'
import base from './base'
import ElementUI from 'element-ui'
// import Viewer from "viewer"; // 已经引用了该插件的css和js文件
// import "bootstrap/dist/css/bootstrap.min.css"; // 采用CDN引入

// 完整引入的组件样式
// import "element-ui/lib/theme-chalk/index.css";
import './assets/css/element-variables.scss'

// Viewer 图片查看器插件
import './assets/css/viewer.min.css'
import './assets/css/viewer.min.js'

import './assets/icon/iconfont.css'
import App from './App.vue'
import router from './router'
import store from './store'
import VueClipboard from 'vue-clipboard2'
// import common from './common.js'

// Video.js 无发现项目使用情况
// import Video from 'video.js'
// import 'video.js/dist/video-js.css'  // 采用CDN引入

import 'vue-video-player/src/custom-theme.css'

// Vue.prototype.$common = common   // 注册为全局变量
Vue.use(VueClipboard)
Vue.config.productionTip = false

Vue.use(base)
Vue.use(ElementUI)
// Vue.use(Viewer);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
